// Descrição em linguagem simples do que cada parâmetro de exame mede —
// mostrada no popup de informação dos mini gráficos da aba Exames.
// Cobre só o significado geral do marcador, sem interpretar o resultado.
const EXAM_EXPLANATIONS = {
  // Hemograma
  'Hemácias': 'Glóbulos vermelhos do sangue, responsáveis por transportar oxigênio dos pulmões para o resto do corpo.',
  'Hemoglobina': 'Proteína dentro das hemácias que carrega o oxigênio. É o principal número usado pra avaliar anemia.',
  'Hematócrito': 'Percentual do sangue ocupado por hemácias. Acompanha a hemoglobina na avaliação de anemia ou desidratação.',
  'VCM': 'Volume médio de cada hemácia. Ajuda a identificar o tipo de anemia (célula pequena, normal ou grande).',
  'HCM': 'Quantidade média de hemoglobina dentro de cada hemácia.',
  'CHCM': 'Concentração de hemoglobina dentro das hemácias, em relação ao volume delas.',
  'RDW': 'Mede o quanto as hemácias variam de tamanho entre si. Ajuda a diferenciar tipos de anemia.',
  'Leucócitos': 'Glóbulos brancos, que fazem parte da defesa do corpo contra infecções. Sobem em infecções e inflamações.',
  'Neutrófilos %': 'Percentual de neutrófilos entre os leucócitos — o tipo mais comum de defesa contra bactérias.',
  'Neutrófilos abs.': 'Quantidade absoluta de neutrófilos no sangue.',
  'Linfócitos %': 'Percentual de linfócitos entre os leucócitos — células de defesa ligadas principalmente a infecções virais.',
  'Linfócitos abs.': 'Quantidade absoluta de linfócitos no sangue.',
  'Plaquetas': 'Células responsáveis pela coagulação do sangue, evitando sangramentos.',

  // Bioquímica
  'Glicose/Glicemia': 'Quantidade de açúcar no sangue. Usada pra avaliar diabetes e controle glicêmico.',
  'Creatinina': 'Substância eliminada pelos rins. É o principal marcador usado pra avaliar a função renal.',
  'TFG': 'Taxa de Filtração Glomerular — estimativa de quanto sangue os rins conseguem filtrar por minuto.',
  'Ureia': 'Outro produto eliminado pelos rins, usado junto com a creatinina pra avaliar a função renal.',
  'Potássio': 'Mineral essencial pro funcionamento do coração e dos músculos.',
  'Sódio': 'Mineral que ajuda a controlar a quantidade de água no corpo e a pressão arterial.',
  'Magnésio': 'Mineral envolvido em centenas de funções do corpo, incluindo músculos e nervos.',
  'Cálcio Iônico': 'Forma ativa do cálcio no sangue, importante pra músculos, nervos e coagulação.',
  'Cloro': 'Mineral que trabalha junto com o sódio e o potássio no equilíbrio de líquidos do corpo.',
  'PCR': 'Proteína C Reativa — marcador de inflamação no corpo. Sobe em infecções, inflamações e após cirurgias.',
  'Bilirrubina Total': 'Substância gerada na quebra das hemácias velhas, processada pelo fígado.',
  'Bilirrubina Direta': 'Fração da bilirrubina já processada pelo fígado.',
  'Bilirrubina Indireta': 'Fração da bilirrubina ainda não processada pelo fígado.',
  'TGO (AST)': 'Enzima presente no fígado (e também no coração/músculos). Sobe quando há lesão nessas células.',
  'TGP (ALT)': 'Enzima mais específica do fígado — sobe principalmente quando há lesão hepática.',
  'Fosfatase Alcalina': 'Enzima ligada ao fígado e aos ossos, usada na avaliação dessas duas áreas.',
  'GGT': 'Enzima do fígado, sensível a álcool e alguns medicamentos.',
  'Amilase': 'Enzima produzida principalmente pelo pâncreas, usada na avaliação de pancreatite.',
  'Lipase': 'Outra enzima do pâncreas, mais específica que a amilase pra avaliar o pâncreas.',
  'Ácido Úrico': 'Substância eliminada pelos rins. Em excesso, pode causar gota e pedras nos rins.',

  // Marcadores cardíacos
  'Troponina': 'Proteína liberada quando há lesão no músculo do coração. Principal marcador de infarto.',
  'NT-ProBNP': 'Substância liberada pelo coração quando ele está sob esforço, usada na avaliação de insuficiência cardíaca.',
  'CK Massa': 'Fração da enzima CK ligada ao músculo do coração.',
  'CPK Total': 'Enzima presente no coração e nos músculos em geral. Sobe em lesão muscular ou cardíaca.',

  // Coagulação
  'TTPA': 'Tempo de Tromboplastina Parcial Ativada — mede uma das vias da coagulação do sangue.',
  'Relação TTPA': 'Compara o TTPA da pessoa com um valor de referência do laboratório.',
  'Tempo Protrombina': 'Mede outra via da coagulação do sangue, relacionada a alguns fatores produzidos pelo fígado.',
  'INR': 'Padroniza o Tempo de Protrombina entre laboratórios diferentes — muito usado pra ajustar anticoagulantes.',

  // Gasometria
  'pH': 'Mede se o sangue está mais ácido ou mais alcalino que o normal.',
  'pCO2': 'Quantidade de gás carbônico dissolvido no sangue, relacionada à respiração.',
  'pO2': 'Quantidade de oxigênio dissolvido no sangue.',
  'HCO3': 'Bicarbonato — substância que ajuda a manter o equilíbrio ácido-base do sangue.',
  'BE': 'Excesso de Base — indica se há sobra ou falta de substâncias básicas no sangue.',
  'SO2': 'Saturação de oxigênio — percentual da hemoglobina que está carregando oxigênio.',
  'Ácido Lático': 'Substância que se acumula quando os tecidos não recebem oxigênio suficiente.',
};

export default EXAM_EXPLANATIONS;
